import { render } from "./CitiesEdit.vue?vue&type=template&id=2388cf78"
import script from "./CitiesEdit.vue?vue&type=script&lang=js"
export * from "./CitiesEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__